import React from 'react';
import './RegisterModal.css'; // You will create this CSS file to match the design
import moment from "moment"
import { Spinner } from "@chakra-ui/react";

const RegisterModal = ({ onClose, onRegister, selectedTimeSlot, isSubmitting }) => {
  const handleFormSubmit = (event) => {
    event.preventDefault();
    onRegister();
  };

  return (
    <div className="modal-backdrop">
      <div className="register-modal">
        <div className="modal-header">
          <h2>{selectedTimeSlot.service_name} Appointment</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-content">
          <p>Your appointment is
            with {selectedTimeSlot.title} {selectedTimeSlot.name} on {moment(selectedTimeSlot.date).format('LL')} at {selectedTimeSlot.time}.</p>
          <form onSubmit={handleFormSubmit}>
            <button disabled={isSubmitting} type="submit" className="confirm-button"> {isSubmitting ?
              <Spinner size="sm"/> : "Confirm"}</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;
